<div class="max-w-2xl mx-auto p-4" data-controller="chat">
  <h1 class="text-2xl font-bold mb-6">Chat Room</h1>

  <%# Subscribe to real-time updates %>
  <%= turbo_stream_from "chat_room" %>

  <%# Messages container - broadcasts append here %>
  <div id="messages"
       class="space-y-4 mb-8 h-96 overflow-y-auto border rounded p-4 bg-gray-50">
    <%= render @messages %>
  </div>

  <%# New message form - clears input after successful submission %>
  <%= form_with model: @message, class: "space-y-4",
      data: { action: "turbo:submit-end->chat#clearInput" } do |form| %>
    <div class="flex gap-4">
      <div class="w-1/4">
        <%= form.text_field :username,
            placeholder: "Your name",
            value: cookies[:chat_username],
            class: "w-full border rounded p-2" %>
      </div>
      <div class="flex-1">
        <%= form.text_field :body,
            placeholder: "Type a message...",
            autofocus: true,
            class: "w-full border rounded p-2",
            data: { chat_target: "body" } %>
      </div>
      <%= form.submit "Send",
          class: "bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700" %>
    </div>
  <% end %>
</div>
